(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aniverse-collection-subcategories"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = (scope = document) => {
    const navs = scope.matches?.('.av-subcategories') ? [scope] : scope.querySelectorAll('.av-subcategories');

    navs.forEach((nav) => {
      if (nav.dataset.inlineFilterReady) return;

      const all = nav.querySelector('[data-filter-all]');
      const preorder = nav.querySelector('[data-filter-preorder]');
      const chips = [...nav.querySelectorAll('[data-filter-collection-url]')];
      if (!all || !preorder) return;

      const results = document.querySelector('results-list[section-id]');
      const grid = results?.querySelector('.product-grid');
      if (!results || !grid) return;

      nav.dataset.inlineFilterReady = 'true';

      const scroller = nav.querySelector('.av-subcategories__scroller');
      if (scroller && !scroller.dataset.scrollWheelReady) {
        scroller.dataset.scrollWheelReady = 'true';

        scroller.addEventListener('wheel', (event) => {
          if (scroller.scrollWidth <= scroller.clientWidth) return;

          const delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX)
            ? event.deltaY
            : event.deltaX;

          if (!delta) return;

          const atStart = scroller.scrollLeft <= 0;
          const atEnd = Math.ceil(scroller.scrollLeft + scroller.clientWidth) >= scroller.scrollWidth;

          if ((delta < 0 && atStart) || (delta > 0 && atEnd)) return;

          event.preventDefault();
          scroller.scrollLeft += delta;
        }, { passive: false });
      }

      const sectionId = results.getAttribute('section-id');
      const status = nav.querySelector('[data-subcategory-status]');
      const pager = results.querySelector('.pagination');
      const aggregateSubcategories = nav.dataset.aggregateSubcategories === 'true';
      const cache = new Map();
      let selected = all;
      let requestId = 0;

      const productsPerPage = 24;
      let activeCards = [];
      let currentPage = 1;
      const pageNav = document.createElement('nav');
      pageNav.className = 'av-subcategories__pagination';
      pageNav.setAttribute('aria-label', 'Toodete leheküljed');
      pageNav.hidden = true;
      grid.after(pageNav);

      const displayPage = (page, scroll = false) => {
        const totalPages = Math.max(1, Math.ceil(activeCards.length / productsPerPage));
        currentPage = Math.max(1, Math.min(totalPages, page));
        const start = (currentPage - 1) * productsPerPage;
        grid.replaceChildren(...activeCards.slice(start, start + productsPerPage));
        grid.dataset.lastPage = '1';

        pageNav.replaceChildren();
        pageNav.hidden = totalPages <= 1;

        if (totalPages > 1) {
          const addButton = (label, target, disabled = false, current = false, accessibleLabel = '') => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'av-subcategories__page-button';
            button.textContent = label;
            if (accessibleLabel) button.setAttribute('aria-label', accessibleLabel);
            if (current) {
              button.classList.add('av-subcategories__page-button--current');
              button.setAttribute('aria-current', 'page');
            }
            button.disabled = disabled;
            button.addEventListener('click', () => displayPage(target, true));
            pageNav.appendChild(button);
          };

          addButton('‹', currentPage - 1, currentPage === 1, false, 'Eelmine leht');
          for (let page = 1; page <= totalPages; page++) {
            addButton(String(page), page, page === currentPage, page === currentPage, 'Lehekülg ' + page);
          }
          addButton('›', currentPage + 1, currentPage === totalPages, false, 'Järgmine leht');
        }

        if (scroll) {
          grid.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        }
      };

      const setStatus = (message) => {
        if (!status) return;
        status.textContent = message;
        status.hidden = !message;
      };

      const setCount = (count) => {
        document.querySelectorAll('[data-testid="products-count"] span[role="status"]').forEach((el) => {
          el.textContent = count + ' toodet';
        });
      };

      const select = (chip) => {
        if (selected) {
          selected.classList.remove('av-subcategories__chip--current');
          selected.removeAttribute('aria-current');
        }
        selected = chip;
        chip.classList.add('av-subcategories__chip--current');
        chip.setAttribute('aria-current', 'true');
      };

      const fetchPage = async (url, page) => {
        const target = new URL(url, window.location.href);
        target.searchParams.delete('section_id');
        target.searchParams.set('page', String(page));
        target.searchParams.set('section_id', sectionId);

        const response = await fetch(target.toString(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Unable to load collection');

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const list = html.querySelector('results-list .product-grid');
        if (!list) {
          if (html.querySelector('.main-collection-grid__empty')) return { cards: [], pages: 1 };
          throw new Error('Collection grid not found');
        }

        return {
          cards: [...list.querySelectorAll(':scope > .product-grid__item')],
          pages: Number(list.dataset.lastPage) || 1
        };
      };

      const fetchCollection = async (url) => {
        const resolved = new URL(url, window.location.href);
        const key = resolved.pathname + resolved.search;
        if (cache.has(key)) return cache.get(key).map((node) => node.cloneNode(true));

        const first = await fetchPage(url, 1);
        if (first.pages > 250) throw new Error('Too many pages');
        const rest = [];
        for (let start = 2; start <= first.pages; start += 5) {
          const batch = await Promise.all(Array.from(
            { length: Math.min(5, first.pages - start + 1) },
            (_, i) => fetchPage(url, start + i)
          ));
          rest.push(...batch);
        }

        const seen = new Set();
        const cards = [first.cards, ...rest.map((x) => x.cards)].flat().filter((card) => {
          const id = card.dataset.productId;
          if (!id || seen.has(id)) return false;
          seen.add(id);
          return true;
        });

        cache.set(key, cards.map((node) => node.cloneNode(true)));
        return cards;
      };

      const renderCollection = async (chip, url) => {
        const id = ++requestId;
        nav.querySelectorAll('[data-filter-pending]').forEach((el) => el.removeAttribute('data-filter-pending'));
        chip.setAttribute('data-filter-pending', 'true');
        results.setAttribute('aria-busy', 'true');
        setStatus('Laadin tooteid…');

        try {
          const cards = await fetchCollection(url);
          if (id !== requestId) return;

          activeCards = cards.filter((card) => card.dataset.avKind === 'stock' || card.dataset.avKind === 'preorder');
          displayPage(1);
          results.dataset.avReady = 'true';

          if (pager) pager.style.display = 'none';
          select(chip);
          setCount(activeCards.length);
          setStatus(activeCards.length ? '' : 'Selles kategoorias ei ole praegu tooteid.');
        } catch (error) {
          if (id === requestId) setStatus('Tooteid ei õnnestunud laadida. Proovi uuesti.');
        } finally {
          if (id === requestId) {
            results.removeAttribute('aria-busy');
            chip.removeAttribute('data-filter-pending');
          }
        }
      };

      // Preserve the accessory page's merged assortment, including the parent collection.
      const renderInventory = async (chip, kind) => {
        const id = ++requestId;
        nav.querySelectorAll('[data-filter-pending]').forEach((el) => el.removeAttribute('data-filter-pending'));
        chip.setAttribute('data-filter-pending', 'true');
        results.setAttribute('aria-busy', 'true');
        setStatus('Laadin tooteid…');
        try {
          const urls = aggregateSubcategories && chips.length
            ? [all.href, ...chips.map((c) => c.dataset.filterCollectionUrl)]
            : [all.href];
          const groups = await Promise.all(urls.map((url) => fetchCollection(url)));
          if (id !== requestId) return;
          const seen = new Set();
          activeCards = groups.flat().filter((card) => {
            const key = card.dataset.productId;
            if (!key || seen.has(key)) return false;
            seen.add(key);
            return card.dataset.avKind === kind;
          });
          displayPage(1);
          results.dataset.avReady = 'true';
          if (pager) pager.style.display = 'none';
          select(chip);
          setCount(activeCards.length);
          setStatus(activeCards.length ? '' : 'Selles kategoorias ei ole praegu tooteid.');
        } catch (error) {
          if (id === requestId) setStatus('Tooteid ei õnnestunud laadida. Proovi uuesti.');
        } finally {
          if (id === requestId) {
            results.removeAttribute('aria-busy');
            chip.removeAttribute('data-filter-pending');
          }
        }
      };

      all.addEventListener('click', (event) => {
        event.preventDefault();
        renderInventory(all, 'stock');
      });
      preorder.addEventListener('click', (event) => {
        event.preventDefault();
        renderInventory(preorder, 'preorder');
      });
      chips.forEach((chip) => {
        chip.addEventListener('click', (event) => {
          event.preventDefault();
          renderCollection(chip, chip.dataset.filterCollectionUrl);
        });
      });
      const view = new URL(window.location.href).searchParams.get('av_view');
      renderInventory(view === 'preorder' ? preorder : all, view === 'preorder' ? 'preorder' : 'stock');
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aniverse-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init = (root = document) => {
  const sections = root.matches?.('.av-reviews') ? [root] : root.querySelectorAll('.av-reviews');
  sections.forEach(section => {
   if(section.dataset.avReviewsReady) return;
   const track=section.querySelector('[data-review-track]');if(!track)return;
   section.dataset.avReviewsReady='true';
   const cards=[...track.querySelectorAll('.av-review')];
   const prev=section.querySelector('[data-review-prev]'), next=section.querySelector('[data-review-next]');
   const controls=section.querySelector('[data-review-navigation]');
   const count=section.querySelector('[data-review-index]');
   const progress=section.querySelector('[data-review-progress]');
   const position=(card)=>card.getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft;
   const update=()=>{
    const max=Math.max(0,track.scrollWidth-track.clientWidth),x=track.scrollLeft;
    if(controls)controls.hidden=max<=2;
    if(prev)prev.disabled=x<=2;
    if(next)next.disabled=x>=max-2;
    if(count){let current=0;cards.forEach((card,i)=>{if(position(card)<=x+6)current=i;});count.textContent=String(current+1).padStart(2,'0');}
    if(progress)progress.style.width=(max>0?Math.min(1,Math.max(0,x/max))*100:100)+'%';
   };
   const move=(direction)=>{
    const x=track.scrollLeft,offsets=cards.map(position);
    const target=direction>0?offsets.find(n=>n>x+5):offsets.slice().reverse().find(n=>n<x-5);
    if(target===undefined)return;
    const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    track.scrollTo({left:target,behavior:reduced?'auto':'smooth'});
   };
   prev?.addEventListener('click',()=>move(-1));
   next?.addEventListener('click',()=>move(1));
   // Touchscreens use native horizontal scroll + scroll-snap. On a desktop,
   // mouse/trackpad users can also swipe by dragging the review cards.
   let drag=null;
   track.addEventListener('pointerdown',event=>{
    if(event.pointerType!=='mouse'||event.button!==0||track.scrollWidth<=track.clientWidth+2)return;
    if(event.target.closest('button,a,input,textarea,select'))return;
    drag={id:event.pointerId,startX:event.clientX,startScroll:track.scrollLeft,moved:false};
   });
   track.addEventListener('pointermove',event=>{
    if(!drag||event.pointerId!==drag.id)return;
    const delta=event.clientX-drag.startX;
    if(!drag.moved&&Math.abs(delta)<5)return;
    if(!drag.moved){
     drag.moved=true;
     track.classList.add('is-dragging');
     track.setPointerCapture?.(event.pointerId);
    }
    track.scrollLeft=drag.startScroll-delta;
    event.preventDefault();
   });
   const finishDrag=event=>{
    if(!drag||event.pointerId!==drag.id)return;
    const wasMoved=drag.moved;
    drag=null;
    if(track.hasPointerCapture?.(event.pointerId))track.releasePointerCapture(event.pointerId);
    track.classList.remove('is-dragging');
    if(wasMoved){
     const current=track.scrollLeft;
     const nearest=cards.reduce((best,card)=>{
      const x=position(card);
      return Math.abs(x-current)<Math.abs(best-current)?x:best;
     },position(cards[0]));
     track.scrollTo({left:nearest,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    update();
   };
   track.addEventListener('pointerup',finishDrag);
   track.addEventListener('pointercancel',finishDrag);
   track.addEventListener('keydown',event=>{
    if(event.key==='ArrowRight'||event.key==='ArrowLeft'){
     event.preventDefault();
     move(event.key==='ArrowRight'?1:-1);
    }
   });
   track.addEventListener('scroll',update,{passive:true});
   if('ResizeObserver' in window){const observer=new ResizeObserver(update);observer.observe(track);section.addEventListener('shopify:section:unload',()=>observer.disconnect(),{once:true});}
   else window.addEventListener('resize',update);
   update();
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});else init();
 document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aniverse-vali-oma-universum-aaa"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initDeck = (root = document) => {
    const sections =
      root.matches?.('.av-deck')
        ? [root]
        : root.querySelectorAll('.av-deck');

    sections.forEach((section) => {
      if (section.dataset.avDeckReady === 'true') return;

      const stage = section.querySelector('[data-av-stage]');
      const cards = [...section.querySelectorAll('[data-av-card]')];
      const prev = section.querySelector('[data-av-prev]');
      const next = section.querySelector('[data-av-next]');
      const current = section.querySelector('[data-av-current]');
      const total = section.querySelector('[data-av-total]');
      const progress = section.querySelector('[data-av-progress]');

      if (!stage || !cards.length) return;

      section.dataset.avDeckReady = 'true';

      let activeIndex = 0;
      let dragging = false;
      let startX = 0;
      let startY = 0;
      let dragX = 0;
      let draggedFarEnoughToBlockClick = false;

      const pad2 = (value) =>
        String(value).padStart(2, '0');

      const getPeek = () =>
        window.matchMedia('(max-width: 749px)').matches
          ? 34
          : 92;

      const getSideShift = () => {
        const activeCard = cards[activeIndex] || cards[0];
        const cardWidth =
          activeCard.getBoundingClientRect().width;

        const isMobile =
          window.matchMedia('(max-width: 749px)').matches;

        if (isMobile) {
          return (
            stage.clientWidth / 2 +
            cardWidth / 2 -
            getPeek()
          );
        }

        /*
          Desktop card center lives at 68% of the stage width.
          The next card sits mostly outside the right edge,
          leaving only a deliberate tilted peek.
        */
        const activeCenter = stage.clientWidth * .68;

        return (
          stage.clientWidth -
          activeCenter +
          cardWidth / 2 -
          getPeek()
        );
      };

      const updateMeta = () => {
        if (current) {
          current.textContent =
            pad2(activeIndex + 1);
        }

        if (total) {
          total.textContent =
            pad2(cards.length);
        }

        if (progress) {
          progress.style.width =
            `${((activeIndex + 1) / cards.length) * 100}%`;
        }
      };

      const applyDeck = (drag = 0) => {
        const sideShift = getSideShift();
        const draggingLeft = drag < 0;
        const draggingRight = drag > 0;
        const isMobile =
          window.matchMedia('(max-width: 749px)').matches;

        cards.forEach((card, index) => {
          const relative = index - activeIndex;
          const abs = Math.abs(relative);

          let x = 0;
          let y = 0;
          let rotate = 0;
          let scale = 1;
          let opacity = 1;
          let z = 100;

          if (relative === 0) {
            /*
              Active card moves only slightly while dragging.
              On desktop this feels like the top card in a real deck.
            */
            x = drag * (isMobile ? .88 : .34);
            rotate = Math.max(
              -3.4,
              Math.min(3.4, drag * .008)
            );
            scale =
              1 - Math.min(Math.abs(drag) / 2600, .018);
            z = 200;
          }

          if (relative > 0) {
            /*
              Future card peeks from the right.
              While swiping left it travels over the current card.
            */
            x =
              sideShift +
              Math.min((relative - 1) * 10, 24);

            y =
              16 +
              Math.min((relative - 1) * 7, 22);

            rotate =
              5.2 +
              Math.min((relative - 1) * 1.15, 3.2);

            scale =
              Math.max(1 - relative * .024, .91);

            opacity =
              Math.max(1 - (relative - 1) * .12, .60);

            z = 180 - relative;

            if (draggingLeft && relative === 1) {
              const progress = Math.min(
                Math.abs(drag) / 260,
                1
              );

              x =
                sideShift * (1 - progress);

              y =
                16 * (1 - progress);

              rotate =
                5.2 * (1 - progress);

              scale =
                .976 + progress * .024;

              opacity = 1;

              /*
                As soon as the next card starts moving,
                place it above the current card so it literally
                covers it instead of pushing it away.
              */
              z = 260;
            }
          }

          if (relative < 0) {
            if (isMobile) {
              /*
                Keep the existing compact mobile behavior.
              */
              x =
                -sideShift -
                34 -
                Math.min((abs - 1) * 18, 50);

              y =
                10 +
                Math.min((abs - 1) * 7, 20);

              rotate =
                -4 -
                Math.min((abs - 1) * 1.1, 3);

              scale =
                Math.max(1 - abs * .025, .90);

              opacity =
                Math.max(.74 - (abs - 1) * .14, .34);

              z = 70 - abs;
            } else {
              /*
                Desktop: previous cards stay directly underneath
                the active card, like a physical stack.
                Only a tiny offset/rotation reveals that another
                card exists below.
              */
              x = Math.min(abs * -5, -18);
              y = Math.min(abs * 8, 28);
              rotate = Math.max(abs * -1.1, -3.6);
              scale = Math.max(1 - abs * .012, .95);
              opacity = Math.max(1 - (abs - 1) * .10, .70);
              z = 150 - abs;

              if (draggingRight && relative === -1) {
                const progress = Math.min(
                  Math.abs(drag) / 260,
                  1
                );

                /*
                  Pull the current top card rightward,
                  revealing the previous card underneath.
                */
                x = -5 + progress * 12;
                y = 8 * (1 - progress);
                rotate = -1.1 * (1 - progress);
                scale = .988 + progress * .012;
                opacity = 1;
              }
            }
          }

          card.classList.toggle(
            'is-active',
            relative === 0
          );

          card.setAttribute(
            'aria-hidden',
            relative === 0 ? 'false' : 'true'
          );

          card.style.setProperty(
            '--av-x',
            `${x}px`
          );

          card.style.setProperty(
            '--av-y',
            `${y}px`
          );

          card.style.setProperty(
            '--av-r',
            `${rotate}deg`
          );

          card.style.setProperty(
            '--av-s',
            scale.toFixed(3)
          );

          card.style.setProperty(
            '--av-o',
            opacity.toFixed(3)
          );

          card.style.setProperty(
            'z-index',
            String(z),
            'important'
          );
        });

        updateMeta();
      };

      const goTo = (index) => {
        activeIndex = Math.max(
          0,
          Math.min(cards.length - 1, index)
        );

        dragX = 0;
        applyDeck(0);
      };

      prev?.addEventListener(
        'click',
        () => goTo(activeIndex - 1)
      );

      next?.addEventListener(
        'click',
        () => goTo(activeIndex + 1)
      );

      stage.addEventListener(
        'keydown',
        (event) => {
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goTo(activeIndex + 1);
          }

          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(activeIndex - 1);
          }
        }
      );

      stage.addEventListener(
        'pointerdown',
        (event) => {
          if (event.button !== undefined && event.button !== 0) {
            return;
          }

          /*
            Links/buttons must behave like normal clickable controls.
            Do not start drag or capture the pointer when the user
            presses a product, CTA, or another interactive element.
          */
          const interactive =
            event.target.closest(
              'a, button, input, select, textarea, label'
            );

          if (interactive) {
            dragging = false;
            dragX = 0;
            draggedFarEnoughToBlockClick = false;
            return;
          }

          dragging = true;
          dragX = 0;
          startX = event.clientX;
          startY = event.clientY;
          draggedFarEnoughToBlockClick = false;

          stage.classList.add('is-dragging');

          stage.setPointerCapture?.(
            event.pointerId
          );
        }
      );

      stage.addEventListener(
        'pointermove',
        (event) => {
          if (!dragging) return;

          const dx = event.clientX - startX;
          const dy = event.clientY - startY;

          /*
            If the gesture is mostly vertical, let the page scroll.
          */
          if (
            Math.abs(dy) > Math.abs(dx) &&
            Math.abs(dy) > 10
          ) {
            return;
          }

          dragX = dx;

          if (Math.abs(dx) > 7) {
            draggedFarEnoughToBlockClick = true;
          }

          /*
            Give extra resistance at the ends of the deck.
          */
          if (
            (activeIndex === 0 && dx > 0) ||
            (activeIndex === cards.length - 1 && dx < 0)
          ) {
            dragX *= .28;
          }

          applyDeck(dragX);
        }
      );

      const finishDrag = (event) => {
        if (!dragging) return;

        dragging = false;

        stage.classList.remove(
          'is-dragging'
        );

        stage.releasePointerCapture?.(
          event.pointerId
        );

        const threshold = Math.min(
          76,
          stage.clientWidth * .08
        );

        if (
          dragX < -threshold &&
          activeIndex < cards.length - 1
        ) {
          activeIndex += 1;
        } else if (
          dragX > threshold &&
          activeIndex > 0
        ) {
          activeIndex -= 1;
        }

        dragX = 0;
        applyDeck(0);
      };

      stage.addEventListener(
        'pointerup',
        finishDrag
      );

      stage.addEventListener(
        'pointercancel',
        finishDrag
      );

      stage.addEventListener(
        'click',
        (event) => {
          if (!draggedFarEnoughToBlockClick) {
            return;
          }

          const link =
            event.target.closest('a');

          if (link) {
            event.preventDefault();
            event.stopPropagation();
          }

          draggedFarEnoughToBlockClick = false;
        },
        true
      );

      /*
        Horizontal trackpad gestures move through the deck.
        Normal vertical page scrolling is untouched.
      */
      let wheelLock = false;

      stage.addEventListener(
        'wheel',
        (event) => {
          const horizontalIntent =
            Math.abs(event.deltaX) >
            Math.abs(event.deltaY);

          if (!horizontalIntent) return;

          event.preventDefault();

          if (wheelLock) return;

          if (
            event.deltaX > 18 &&
            activeIndex < cards.length - 1
          ) {
            goTo(activeIndex + 1);
            wheelLock = true;
          }

          if (
            event.deltaX < -18 &&
            activeIndex > 0
          ) {
            goTo(activeIndex - 1);
            wheelLock = true;
          }

          if (wheelLock) {
            window.setTimeout(
              () => {
                wheelLock = false;
              },
              520
            );
          }
        },
        { passive: false }
      );

      let resizeTimer = 0;

      window.addEventListener(
        'resize',
        () => {
          window.clearTimeout(
            resizeTimer
          );

          resizeTimer = window.setTimeout(
            () => applyDeck(0),
            90
          );
        }
      );

      applyDeck(0);
    });
  };

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => initDeck()
    );
  } else {
    initDeck();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initDeck(event.target);
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aniverse-video-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initAniVerseHeroGlow = (root = document) => {
    const heroes =
      root.matches?.('.av-video-hero')
        ? [root]
        : root.querySelectorAll('.av-video-hero');

    heroes.forEach((hero) => {
      if (hero.dataset.avGlowReady === 'true') return;

      const content =
        hero.querySelector('.av-video-hero__content');

      if (!content) return;

      hero.dataset.avGlowReady = 'true';

      const coarsePointer =
        window.matchMedia(
          '(pointer: coarse)'
        ).matches;

      const reducedMotion =
        window.matchMedia(
          '(prefers-reduced-motion: reduce)'
        ).matches;

      let touching = false;
      let lastInteraction = 0;
      const idleStart = performance.now();

      const setGlowPosition = (
        clientX,
        clientY
      ) => {
        const rect =
          content.getBoundingClientRect();

        let x =
          (
            (clientX - rect.left) /
            rect.width
          ) * 100;

        let y =
          (
            (clientY - rect.top) /
            rect.height
          ) * 100;

        x =
          Math.max(
            -25,
            Math.min(125, x)
          );

        y =
          Math.max(
            -25,
            Math.min(125, y)
          );

        content.style.setProperty(
          '--av-glow-x',
          `${x}%`
        );

        content.style.setProperty(
          '--av-glow-y',
          `${y}%`
        );
      };

      hero.addEventListener(
        'pointermove',
        (event) => {
          if (
            event.pointerType === 'touch' &&
            !touching
          ) {
            return;
          }

          lastInteraction =
            performance.now();

          setGlowPosition(
            event.clientX,
            event.clientY
          );

          content.classList.add(
            'is-av-glow-active'
          );
        }
      );

      hero.addEventListener(
        'pointerenter',
        () => {
          if (!coarsePointer) {
            content.classList.add(
              'is-av-glow-active'
            );
          }
        }
      );

      hero.addEventListener(
        'pointerleave',
        () => {
          if (!coarsePointer) {
            content.classList.remove(
              'is-av-glow-active'
            );
          }
        }
      );

      hero.addEventListener(
        'pointerdown',
        (event) => {
          if (
            event.pointerType !== 'touch'
          ) {
            return;
          }

          touching = true;
          lastInteraction =
            performance.now();

          content.classList.add(
            'is-av-glow-active'
          );

          setGlowPosition(
            event.clientX,
            event.clientY
          );
        }
      );

      const stopTouch = () => {
        if (!touching) return;

        touching = false;
        lastInteraction =
          performance.now();

        window.setTimeout(
          () => {
            if (!touching) {
              content.classList.remove(
                'is-av-glow-active'
              );
            }
          },
          500
        );
      };

      window.addEventListener(
        'pointerup',
        stopTouch
      );

      window.addEventListener(
        'pointercancel',
        stopTouch
      );

      if (
        coarsePointer &&
        !reducedMotion
      ) {
        const animateIdleGlow = (
          now
        ) => {
          const timeSinceTouch =
            now - lastInteraction;

          if (
            !touching &&
            timeSinceTouch > 700
          ) {
            const t =
              (now - idleStart) /
              1000;

            const x =
              50 +
              Math.sin(
                t * .48
              ) * 46;

            const y =
              50 +
              Math.cos(
                t * .37
              ) * 42;

            content.style.setProperty(
              '--av-glow-x',
              `${x}%`
            );

            content.style.setProperty(
              '--av-glow-y',
              `${y}%`
            );
          }

          requestAnimationFrame(
            animateIdleGlow
          );
        };

        requestAnimationFrame(
          animateIdleGlow
        );
      }
    });
  };


  const initAniVerseHeroPlayback = (root = document) => {
    const heroes = root.matches?.('.av-video-hero')
      ? [root] : root.querySelectorAll('.av-video-hero');

    heroes.forEach((hero) => {
      if (hero.dataset.avPlaybackReady === 'true') return;
      const video = hero.querySelector('.av-video-hero__media video');
      const button = hero.querySelector('.av-video-hero__play-toggle');
      const poster = hero.querySelector('.av-video-hero__paused-poster');
      if (!video || !button) return;
      hero.dataset.avPlaybackReady = 'true';

      // iPhone Low Power Mode may reject autoplay. Keep playback muted,
      // inline, and user-initiated through an actual button when necessary.
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      const mobile = window.matchMedia('(max-width: 749px)');

      const syncButton = () => {
        button.hidden = !mobile.matches || !video.paused ||
          document.visibilityState !== 'visible';
        if (poster) poster.hidden = button.hidden;
      };

      video.addEventListener('playing', syncButton);
      video.addEventListener('pause', syncButton);
      video.addEventListener('ended', syncButton);
      document.addEventListener('visibilitychange', syncButton);
      mobile.addEventListener?.('change', syncButton);

      button.addEventListener('click', () => {
        // play() must be called synchronously inside the user gesture.
        const result = video.play();
        if (result?.then) {
          result.then(syncButton).catch(() => { button.hidden = false; });
        } else {
          syncButton();
        }
      });

      // Autoplay may be denied silently on Safari; check the actual
      // playback state as well as the promise result.
      if (mobile.matches) {
        window.setTimeout(() => {
          if (video.paused && document.visibilityState === 'visible') {
            const result = video.play();
            if (result?.catch) result.catch(syncButton);
          }
          syncButton();
        }, 700);
      }
    });
  };

  if (
    document.readyState ===
    'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        initAniVerseHeroGlow();
        initAniVerseHeroPlayback();
      }
    );
  } else {
    initAniVerseHeroGlow();
    initAniVerseHeroPlayback();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAniVerseHeroGlow(
        event.target
      );
      initAniVerseHeroPlayback(event.target);
    }
  );
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
